import * as notification from "../utils/notification";

import { HTTP_ERRORS } from "../utils/errors";

export const callService = async (url, options, noJson, noOperationResult) => {
    try {
    const response = await fetch(url, options);
    if (!response.ok) handleError(response);
    else {
      if (noJson) return response.text();
      const data = await response.json();
      if (!noOperationResult && data.hasOwnProperty("success")) {
        if (!data.success) {
          notification.error("", data.errorMessage);
        }
      }
        return data;
    }
  } catch (e) {
    console.log(url);
    console.error(e);
    notification.error("", HTTP_ERRORS._EXCEPTION);
  }
};

const handleError = (response) => {
  if (response.customCode >= 600) {
    notification.error("", "Error de servidor "+ HTTP_ERRORS._600);
  }
  if (response.status >= 500) {
    notification.error("", "Error de servidor "+ HTTP_ERRORS._500);
  } else {
    notification.error("", 
      `Error ${
        response.status === 401 || response.status === 403
          ? HTTP_ERRORS._401
          : HTTP_ERRORS._400
      }`
    );
  }
};

export const callServicePost = async (url, data) => {
    return await callService(url, {
    method: "POST",
    body: data,
    headers: {
      "Content-Type": "Content-Type': 'multipart/form-data",
    },
  });
};

export const callServiceDelete = async (url, noOperationResult) => {
  return await callService(
    url,
    {
      method: "DELETE",
    },
    false,
    noOperationResult
  );
};
